import {
  Box,
  Dialog,
  ToggleButton,
  ToggleButtonGroup,
  useTheme,
} from '@mui/material';
import { tokens } from '../../global/theme/tokens';
import Header from '../../components/special/Header';
import { useTranslation } from 'react-i18next';
import { LeadsCompanies } from './tabs/LeadsCompanies';
import { useEffect, useRef, useState } from 'react';
import { LeadsPersons } from './tabs/LeadsPersons';
import {
  ExoTableToolbar,
  ExoTableToolbarItem,
} from '../../components/exo/ExoTableToolbar';
import AddIcon from '@mui/icons-material/Add';
import ExoDialog from '../../components/exo/ExoDialog';
import { ExoVariants } from '../../components/exo/ExoVariants';
import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import { NewCompanyLead } from '../../components/new/NewCompanyLead';
import { NewPersonLead } from '../../components/new/NewPersonLead';
import Cookies from 'universal-cookie';
import ExoAlert from '../../components/exo/ExoAlert';
import { ExoLeadCategory } from './category/ExoLeadCategory';
import { DBRequest, useConfig } from '../../api/api';
import ClassIcon from '@mui/icons-material/Class';

const Leads = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const config = useConfig();
  const { t } = useTranslation();
  const cookies = new Cookies();

  const [type, setType] = useState('companies');
  const [open, setOpen] = useState(false);

  const leadsCompaniesRef = useRef(null);
  const leadsPersonsRef = useRef(null);
  const [variants, setVariants] = useState([]);

  const [openAlert, setOpenAlert] = useState(false);
  const [openCategories, setOpenCategories] = useState(false);

  const [categories, setCategories] = useState(null);

  function handleCategoriesChange(selectedCategories) {}

  // change the API to lead-categories when implemented in backend
  useEffect(() => {
    DBRequest({
      config,
      path: `lead-categories`,
      onResponse: setCategories,
    });
  }, [config]);

  useEffect(() => {
    setVariants([
      {
        label: t('Lead Company'),
        Icon: AddBusinessIcon,
        content: (
          <NewCompanyLead
            onClose={() => setOpen(false)}
            onCreate={(data) => handleChange(leadsCompaniesRef, data)}
            onUpdate={(data) => handleChange(leadsCompaniesRef, data)}
            startData={{ responsibleUser: { id: cookies.get('userId') } }}
          />
        ),
      },
      {
        label: t('Person'),
        Icon: PersonAddAlt1Icon,
        content: (
          <NewPersonLead
            onClose={() => setOpen(false)}
            onCreate={(data) => handleChange(leadsPersonsRef, data)}
            onUpdate={(data) => handleChange(leadsPersonsRef, data)}
            startData={{ responsibleUser: { id: cookies.get('userId') } }}
          />
        ),
      },
    ]);
  }, [leadsCompaniesRef, leadsPersonsRef]);

  function handleChange(ref, data) {
    if (!ref) return;
    ref.current.addRow(data);
  }

  return (
    <>
      <Box className="flex gap-0 md:gap-8 md:items-center justify-between md:justify-start pr-2 md:flex-row flex-col pb-4 md:pb-0">
        <Header title={t('Leads')} />
        <ToggleButtonGroup
          size="small"
          value={type}
          exclusive
          onChange={(e) => setType(e.target.value)}
          aria-label="Project Status"
          className="backdrop-blur-lg"
        >
          <ToggleButton value="companies">{t('Lead Companies')}</ToggleButton>
          <ToggleButton value="person">{t('Persons')}</ToggleButton>
        </ToggleButtonGroup>
      </Box>
      <ExoTableToolbar>
        <ExoTableToolbarItem
          text={t('New Lead')}
          icon={<AddIcon />}
          onClick={() => setOpen(true)}
        />
        <ExoTableToolbarItem
          text={t('Category')}
          icon={<ClassIcon />}
          onClick={() => setOpenCategories(true)}
        />
      </ExoTableToolbar>

      <LeadsCompanies ref={leadsCompaniesRef} isActive={type === 'companies'} />
      <LeadsPersons ref={leadsPersonsRef} isActive={type === 'person'} />
      <ExoDialog open={open} onClose={() => setOpen(false)} limitWidth>
        <ExoVariants variants={variants} />
      </ExoDialog>

      <ExoAlert
        open={Boolean(openAlert)}
        alert={openAlert || {}}
        onClose={openAlert?.onCancel}
        onSubmit={openAlert?.onSubmit}
      />
      <Dialog
        open={openCategories}
        onClose={() => setOpenCategories(false)}
        sx={{
          '.MuiPaper-root': {
            backgroundImage: 'unset!important',
          },
          '.MuiBackdrop-root': {
            backdropFilter: 'blur(1px)',
            backgroundColor: 'rgba(0, 0, 0, 0.3 )',
          },
        }}
      >
        <ExoLeadCategory
          onChange={handleCategoriesChange}
          onClose={() => setOpenCategories(false)}
          categories={categories}
          setCategories={setCategories}
        />
      </Dialog>
    </>
  );
};

export default Leads;
